/* eslint-disable @typescript-eslint/no-use-before-define */ import { addIntent, createIntentMap, isIntent, mergeIntents } from '../../../intent';
import { VIEW_CONFIG, getViewConfig } from './ViewConfig';
import { setCss, setEvent, setRef } from './propertyProcessors';
const $facade = Symbol('facade');
const EMPTY_OBJECT = {};
function isPropsFacade(props) {
    return $facade in props;
}
export function createPropsFacade(props, cache, tag, css, ref, intents) {
    if (isPropsFacade(props)) {
        return props;
    }
    const viewConfig = createIntentMap({
        cache,
        css,
        props: EMPTY_OBJECT,
        state: {},
        tag
    });
    let propsFacade = createIntentMap({
        [VIEW_CONFIG]: viewConfig,
        [$facade]: true
    }, viewConfig);
    viewConfig.props = propsFacade;
    // In development mode, wrap the facade in a proxy that throws when anyone
    // attempts to assign a property without using mergeProperty.
    if (process.env.NODE_ENV !== 'production') {
        propsFacade = new Proxy(propsFacade, {
            set () {
                throw new Error('Cannot assign properties to props.');
            }
        });
    }
    addIntentsToProps(propsFacade, intents);
    const result = propsFacade;
    mergeProps(result, props);
    if (ref) {
        mergeProperty(result, 'ref', ref);
    }
    return result;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const eventProcessors = {};
const eventRegExp = /^on[A-Z]/;
export function mergeProperty(obj, key, value) {
    const target = getViewConfig(obj).props;
    if (typeof key !== 'string') {
        return;
    }
    switch(key){
        case VIEW_CONFIG:
            const config = getViewConfig(target);
            const valueConfig = value;
            mergeIntents(config, valueConfig);
            if (valueConfig.tag) {
                config.tag = valueConfig.tag;
            }
            return;
        case 'className':
            target.className = target.className ? `${target.className} ${value}` : value;
            return;
        case 'ref':
            setRef(value, target, key);
            return;
        case 'style':
            if (!target.style) {
                target.style = {};
            }
            Object.assign(target.style, value);
            return;
        case 'css':
            setCss(value, target, key);
            return;
        case 'slot':
        case 'slots':
        case 'uses':
            return;
        default:
            if (!(key in eventProcessors)) {
                eventProcessors[key] = key.match(eventRegExp) ? setEvent : null;
            }
            const processor = eventProcessors[key];
            if (processor) {
                processor(value, target, key);
            } else {
                target[key] = value;
            }
    }
}
export function addIntentsToProps(target, source) {
    if (!source) {
        return;
    }
    for(let i = 0; i < source.length; i++){
        const intent = source[i];
        if (intent == null) {
            if (process.env.NODE_ENV !== 'production' && intent === undefined) {
                /* eslint-disable no-console */ console.warn('You are passing an `undefined` intent. This might indicate a bug. For conditional intents, consider using `null` or `false` instead');
                console.warn('The intent came from:');
                console.warn(source);
            /* eslint-enable no-console */ }
        } else if (isIntent(intent)) {
            addIntent(target, intent);
        } else {
            mergeProps(target, intent);
        }
    }
}
export function mergeProps(target, source) {
    addIntentsToProps(target, source.uses);
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        mergeProperty(target, key, source[key]);
    }
}

//# sourceMappingURL=PropsFacade.js.map